import { Stack, Typography } from "@mui/material";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useMemo } from "react";
import { useBoundStore } from "useStore";

export function CmPublishSummary({ allModifiedRowKeys, selectedRows }) {
  const cmEditedRows = useBoundStore((state) => state.cmEditedRows);

  const affectedCampaigns = useMemo(
    () => allModifiedRowKeys.filter((key) => selectedRows[key] === true).length,
    [allModifiedRowKeys, selectedRows],
  );

  const budgetChangesCount = useMemo(
    () =>
      allModifiedRowKeys.filter((key) => {
        if (!selectedRows[key]) return false;
        const row = cmEditedRows[key];
        const f = row?.dailyBudget;
        return (
          f?.valueOriginal !== undefined &&
          f?.valueEdited !== undefined &&
          Number(f.valueEdited) !== Number(f.valueOriginal)
        );
      }).length,
    [allModifiedRowKeys, selectedRows, cmEditedRows],
  );

  const roasChangesCount = useMemo(
    () =>
      allModifiedRowKeys.filter((key) => {
        if (!selectedRows[key]) return false;
        const row = cmEditedRows[key];
        const f = row?.targetRoas;
        return (
          f?.valueOriginal !== undefined &&
          f?.valueEdited !== undefined &&
          Number(f.valueEdited) !== Number(f.valueOriginal)
        );
      }).length,
    [allModifiedRowKeys, selectedRows, cmEditedRows],
  );

  return (
    <Stack
      direction="column"
      spacing={2}
      padding={2}
      sx={{ border: "1px solid #A7A8A880", borderRadius: "8px" }}
    >
      <Typography sx={{ fontSize: 14, textDecoration: "underline" }}>
        <strong>Resumen</strong>
      </Typography>

      <Stack spacing={1}>
        {affectedCampaigns > 0 && (
          <Stack direction="row" spacing={1} alignItems="center">
            <CampaignOutlinedIcon fontSize="small" />
            <Typography>Campañas afectadas:</Typography>
            <strong>{affectedCampaigns}</strong>
          </Stack>
        )}
        {budgetChangesCount > 0 && (
          <Stack direction="row" spacing={1} alignItems="center">
            <AttachMoneyIcon fontSize="small" />
            <Typography>Cambios de presupuesto diario:</Typography>
            <strong>{budgetChangesCount}</strong>
          </Stack>
        )}
        {roasChangesCount > 0 && (
          <Stack direction="row" spacing={1} alignItems="center">
            <TrendingUpIcon fontSize="small" />
            <Typography>Cambios de ROAS objetivo:</Typography>
            <strong>{roasChangesCount}</strong>
          </Stack>
        )}
      </Stack>

      <Stack direction="row" spacing={1} alignItems="center">
        <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>Total:</Typography>
        <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
          {budgetChangesCount + roasChangesCount}
        </Typography>
      </Stack>
    </Stack>
  );
}
